import { DirectionalCell } from './directional-cell.model';

export class JobCell extends DirectionalCell {
    jobTitleId: number;
}